(() => {
  // Set to true to re-enable the popup
  const ENABLE_POPUP = false;

  const STORAGE_SEEN = 'eveline_fv_eveline20_seen';
  const STORAGE_EMAIL = 'eveline_fv_eveline20_email';
  const DISCOUNT_CODE = 'Eveline20';

  const modal = document.getElementById('FirstVisitModal');
  if (!modal) return;
  if (!ENABLE_POPUP) return;

  const closeBtn = modal.querySelector('[data-fv-close]');
  const backdrop = modal.querySelector('[data-fv-backdrop]');
  const form = modal.querySelector('[data-fv-form]');
  const emailInput = modal.querySelector('[data-fv-email]');
  const errorEl = modal.querySelector('[data-fv-error]');
  const copyBtn = modal.querySelector('[data-fv-copy]');

  const open = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => emailInput?.focus(), 50);
  };

  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    try {
      localStorage.setItem(STORAGE_SEEN, '1');
    } catch (_) {}
  };

  const showError = (msg) => {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.classList.add('is-visible');
  };

  const clearError = () => {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.classList.remove('is-visible');
  };

  const isValidEmail = (email) => {
    // Simple but practical validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(String(email || '').trim());
  };

  const submitEmailToShopify = async (email) => {
    // Optional integration: submit to Shopify customer/newsletter endpoint
    // Non-blocking; if it fails, we still reveal the code.
    const body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[tags]', 'newsletter, eveline20');
    body.set('contact[email]', email);

    const res = await fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString(),
      credentials: 'same-origin',
    });
    return !!res?.ok;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    clearError();

    const email = String(emailInput?.value || '').trim();
    if (!isValidEmail(email)) {
      showError('Please enter a valid email address.');
      emailInput?.focus();
      return;
    }

    try {
      localStorage.setItem(STORAGE_EMAIL, email);
    } catch (_) {}

    // Mark as seen once the user provided email (so it never shows again)
    try {
      localStorage.setItem(STORAGE_SEEN, '1');
    } catch (_) {}

    // Optional backend submission. After submit -> close popup.
    try {
      await submitEmailToShopify(email);
    } catch (_) {
      // ignore
    }

    close();
  };

  const onCopy = async () => {
    // Email gate: ask for email first (to keep the offer "locked")
    try {
      const savedEmail = localStorage.getItem(STORAGE_EMAIL);
      if (!savedEmail) {
        showError('Enter your email first to unlock the code.');
        emailInput?.focus();
        return;
      }
    } catch (_) {
      // If localStorage blocked, allow copy
    }
    try {
      await navigator.clipboard.writeText(DISCOUNT_CODE);
      if (copyBtn) copyBtn.textContent = 'Copied';
      setTimeout(() => {
        if (copyBtn) copyBtn.textContent = 'Copy';
      }, 1200);
    } catch (_) {
      // Fallback: select text not implemented; at least show code.
    }
  };

  closeBtn?.addEventListener('click', close);
  backdrop?.addEventListener('click', close);
  form?.addEventListener('submit', onSubmit);
  copyBtn?.addEventListener('click', onCopy);

  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  const shouldShow = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('fv_preview') === '1') return true;
      return !localStorage.getItem(STORAGE_SEEN);
    } catch (_) {
      return true;
    }
  };

  // Delay a bit to avoid clashing with initial render
  if (shouldShow() && !document.documentElement.classList.contains('shopify-design-mode')) {
    window.setTimeout(open, 800);
  }
})();

